// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-container[data-v-cbb9fa66] {\n  width: 100%;\n  height: 4rem;\n  text-align: center;\n}\n.empty-container img[data-v-cbb9fa66] {\n    width: 4.12rem;\n    height: auto;\n}\n.empty-container p[data-v-cbb9fa66] {\n    margin: 0.26667rem 0;\n    font-size: 0.42667rem;\n    color: #8c8c8c;\n    font-weight: 500;\n}\n", ""]);
// Exports
module.exports = exports;
